<!-- 大用户水表总览 -->
<template>
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">大用户水表总览</span>
    </div>
    <div class="content">
      <div class="chart-container">
        <div style="height: 100%;">
          <div ref="waterMeterChart" style="height: 173.5px;">

          </div>
        </div>
      </div>
      <div class="top"></div>
      <div class="middle"></div>
      <div class="bottom"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: 'LeftUserWaterMeter',
  data () {
    return {
      waterMeterUrl: '/smart-water-major-users/major/users/user/user/count/watermetertype',
      waterMeterData: [
        { value: 8000, name: '机械表', percentage: '80%' },
        { value: 2000, name: '远传表', percentage: '20%' },
      ]
    }
  },
  mounted () {
    this.initChart();
  },
  methods: {
    initChart () {
      this.getWaterMeterData();
    },
    getWaterMeterData () {
      this.$http.get(this.waterMeterUrl).then((res) => {
        let jxCount = 0;
        let ycCount = 0;
        res.data.forEach(element => {
          if (element.waterMeterType == 1) {
            jxCount += Number(element.countWaterMeterType);
          } else if (element.waterMeterType == 2) {
            ycCount += Number(element.countWaterMeterType);
          }
        })
        const totalCount = jxCount + ycCount;
        this.waterMeterData = [
          { value: jxCount, name: '机械表', percentage: totalCount > 0 ? Math.round((jxCount / totalCount) * 100) + '%' : '0%' },
          { value: ycCount, name: '远传表', percentage: totalCount > 0 ? Math.round((ycCount / totalCount) * 100) + '%' : '0%' },
        ]
        this.createWaterMeterChart();
      })
    },
    createWaterMeterChart () {
      const chartDom = this.$refs.waterMeterChart;
      const myChart = echarts.init(chartDom);
      //创建Option对象
      let waterMeterOption = {
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '55%'],
            avoidLabelOverlap: false,
            itemStyle: {
              color: function (params) {
                var colorList = ['#26b0ae', '#aff875'];
                return colorList[params.dataIndex];
              },
            },
            // 自定义标签内容
            label: {
              formatter: function (params) {
                // 自定义富文本样式
                return [
                  '{name|' + params.name + '}{value|' + params.value + '}'
                ]; // 用换行符分隔，或者用 '  ' 空格分隔
              },
              rich: {
                name: {
                  color: '#0cefed',  // 名称颜色
                  fontSize: 15,
                  fontWeight: '300',
                  padding: [0, 5, 0, 0]  // 调整间距
                },
                value: {
                  color: '#24a1e1',  // 数值颜色
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              }
            },
            // 标签线设置
            labelLine: {
              show: true,
              length: 10,  // 第一段线长度
              length2: 20, // 第二段线长度
              lineStyle: {
                width: 2,
                color: '#26b0ae'
              },
              z: 10  // 设置层级高于外边框
            },
            data: this.waterMeterData,
            z: 2  // 设置饼图层级
          },
          {
            name: '外边框',
            type: 'pie',
            clockWise: false,
            silent: true,
            labelLine: { show: false },
            radius: ['74%', '74%'],
            center: ['50%', '55%'],
            data: [{
              value: 0,
              itemStyle: {
                normal: {
                  borderWidth: 3,
                  borderColor: 'rgb(26, 61, 109, 1)'
                }
              }
            }],
            z: 1  // 设置层级低于饼图
          },
          {
            name: '内边框',
            type: 'pie',
            clockWise: false,
            silent: true,
            labelLine: { show: false },
            radius: ['36%', '36%'],
            center: ['50%', '55%'],
            data: [{
              value: 0,
              itemStyle: {
                normal: {
                  borderWidth: 3,
                  borderColor: 'rgb(26, 61, 109, 1)'
                }
              }
            }],
            z: 3  // 设置层级
          }
        ]
      };
      myChart.setOption(waterMeterOption);
      
      // 添加点击事件监听，点击饼图数据项或标签时跳转
      myChart.on('click', (params) => {
        if (params.componentType === 'series' && params.seriesType === 'pie') {
          this.handleNumberClick();
        }
      });
      
      // 响应式调整
      window.addEventListener('resize', () => {
        myChart.resize();
      });
    },
    // 处理数字点击跳转
    handleNumberClick() {
      this.$router.push('/bigusers/workbench/userControl/AllUserPage');
    }
  }
}

</script>

<style lang="less" scoped>
.mainWarp {
  height: 186px;
  width: 412px;
  position: relative;


  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    /* 添加相对定位 */
  }

  .chart-container {
    position: absolute;
    top: 25px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    /* 确保在底层 */
  }

  .top {
    flex: 0 0 60px;
    background: url(~@/assets/bigusers/largeScreen/topBox.png) no-repeat;
    background-size: 100% 100%;
    /* 完全填充 */
  }

  .middle {
    flex: 0 0 70%;
    background: url(~@/assets/bigusers/largeScreen/middleBox.png) repeat;
    background-size: 100% auto;
    /* 水平拉伸，垂直平铺 */
  }

  .bottom {
    flex: 0 0 60px;
    background: url(~@/assets/bigusers/largeScreen/bottomBox.png) no-repeat;
    background-size: 100% 100%;
    /* 完全填充 */
  }

  .img-title {
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;
    z-index: 1;
    /* 确保标题在最上层 */

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      width: 264px;
      height: 35px;
    }
  }
}
</style>